import React from 'react';
import { Page } from '../Common/Components/Page';
import { CompartmentManagementContent } from './Components/CompartmentManagementContent';

export const CompartmentManagement = (): React.JSX.Element => (
  <Page title="Compartments" accessKey="compartments" isSearchable={true}>
    <CompartmentManagementContent />
  </Page>
);
